<template>
  <div class="entrance">
    <!-- 活动列表 -->
    <div class="line">
      <div class="flex">
        <v-select
          :options="options"
          v-model="params.status"
          placeholder="请选择活动状态"
          class="item"
        />
        <vs-input
          class="item"
          v-model="params.activityUrl"
          placeholder="请输入活动名称"
        />
        <vs-button @click.prevent="getTableData">
          查询
        </vs-button>
      </div>
      <vs-button v-if="filtering('storeactivities:entrance:add')" @click="addData">新增</vs-button>
    </div>
    <vs-table :data="tableData"  noDataText="暂无数据">
      <template slot="thead">
        <vs-th v-for="(headData, index) in headData" :key="index">
          {{ headData }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="indextr">
            <p>{{ indextr + 1 }}</p>
          </vs-td>
          <vs-td :data="tr.imgUrl">
            <img :src="tr.imgUrl" alt="img" class="tableImg" />
            <!-- <vs-image :src="tr.imgUrl" /> -->
          </vs-td>
          <vs-td :data="tr.activityName">
            {{ tr.activityName }}
          </vs-td>
           <vs-td :data="tr.pushType">
          {{tr.pushType==1?'统一推送':'独立推送'}}</vs-td>
          <vs-td>
            {{ tr.type | getType }}
          </vs-td>

          <vs-td :data="tr.sort">
            {{ tr.sort }}
          </vs-td>
          <vs-td :data="tr.status" class="status">
            <vs-switch v-model="tr.statusFlag" @input="changeStatus(indextr, tr.statusFlag)"/>
          </vs-td>
          <vs-td>
            <vs-button v-if="filtering('storeactivities:entrance:update')" color="primary" type="flat" class="btn" @click="edit(tr)">
              编辑
            </vs-button>
            <vs-button v-if="filtering('storeactivities:entrance:delete')" color="primary" type="flat" class="btn" @click="del(tr)">
              删除
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <gc-vs-pagination
      class="pagination"
      v-if="tableData.length"
      :total="pagination.totalPage"
      v-model="pagination.page"
      :max-items="99999999999">
    </gc-vs-pagination> -->
    <gc-vs-pagination
      :pager="pagination"
      totalName="totalPage"
      pageSizeName="pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>
  </div>
</template>

<script>
import { DistributionApi } from "@/modules/server-api/commodity-sys/distribution";
import constants from "../../../constants.ts";
export default {
  props:{
    pageSize:{
      default:20,
      type: Number
    }
  },
  data() {
    return {
      params: { status: 0, activityUrl: "" },
      options: [
        { label: "关闭", code: 1 },
        { label: "开启", code: 2 }
      ],
      headData: ["序号", "Banner", "名称","推送类型","活动类型", "排序", "状态", "操作"],
      tableData: [],
      activityList: [],
      pagination: {
        totalPage: 1,
        page: 1,
        pageSize: this.pageSize
      },
    };
  },
  filters: {
    getStatus(val) {
      let text = "--";
      switch (val) {
        case 1:
          text = "关闭";
          break;
        case 2:
          text = "开启";
      }
      return text;
    },
    getType(val) {
      const item = constants.typeOptions.find(({ value }) => value === val) || {};
      return item.label;
    },
  },

  async mounted() {
    // await this.loadActivities()
    await this.getTableData();
  },
  watch: {
      // 'pagination.page'() {
      //     this.getTableData();
      // }
  },
  methods: {
    loadActivities(){
      return DistributionApi.activityConfigList({
        page: 0,
        size: 10000,
      }).then(res => {
        this.activityList = res.result.data.map((item) => {
          return {
            label: item.activityName,
            value: item.id,
          }
        })
      })
      return []
    },
    addData() {
      const path = `storeactivities/entrance/0`;
      this.$router.push(path);
    },
    getTableData() {
       this.$vs.loading();
      const { code = 0 } = this.params.status || {};
      DistributionApi.queryEntranceList({
        ...this.params,
        page: this.pagination.page - 1,
        size: this.pagination.pageSize,
        status: code
      }).then(({ result = {} }) => {
        const { data = [], totalPage, totalElements } = result;
        this.tableData = data;
        // this.pagination.totalPage = totalPage
        this.pagination.totalPage = totalElements
        this.handelData()
       this.$vs.loading.close();
      });
    },
    handelData() {
      this.tableData = this.tableData.map(item => {
        // const activityUrl = parseInt(item.activityUrl.replace('id=','')) || ''
        // const temp = this.activityList.find(v => {
        //    return v.value === activityUrl
        // })
        return {
          ...item,
          // activityName: temp.label,
          statusFlag: item.status === 1? false : true
        }
      })
    },
    edit(row) {
      const name = `storeactivities/entrance`;
      this.$router.push({ name, params: row });
    },
    del(row) {
      console.log('item',row)
      this.$vs.dialog({
        type: 'confirm',
        color: '#4090FF',
        title: `提示`,
        text: '确定要删除此项么?',
        acceptText: '确认',
        cancelText: '取消',
        accept: async () => {
          DistributionApi.updateEntrance({ ...row, isDelete: 1 }).then(res => {
            this.getTableData();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "删除成功",
              position: "top-right"
            });
          });
        }
      })

    },
    changeStatus(index, val) {
      const item = this.tableData[index]
      console.log(item)
      const params = {
        activityUrl: item.activityUrl,
        imgUrl: item.imgUrl,
        sort: item.sort,
        status: val ? 2 : 1,
        id: item.id
      };
      //编辑
      DistributionApi.updateEntrance({...params }).then(res => {
        // console.log('23333',res)
        if(res.succ === 1) {
          this.$notifySuccess('更新成功');
        } else {
          this.$notifyError('更新失败');
        }
        this.getTableData()
      });
      return;
    },
    //更改每页条数
    handleSizeChange(val){
      this.pagination.pageSize = val;
      this.$emit("changePageSize", val);
      this.getTableData();
    },
    handleCurrentChange(val){
      this.pagination.page = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped lang="scss">
.line {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.item {
  margin-right: 10px;
  width: 200px;
}
.tableImg {
  width: 100px;
}
.entrance {
  .vs-button {
    padding: 6px 24px !important;
  }
  .btn{
    padding: 2px 15px !important;
  }
  .status {
    /deep/ span {
      display: inline-block;
    }
  }
}
</style>
